export type ContinentCode =
  | 'northamerica'
  | 'southamerica'
  | 'europe'
  | 'africa'
  | 'asia'
  | 'australia'
  | 'me'

type Continent = {
  code: ContinentCode
  title: string
}

export const continents: Continent[] = [
  {
    code: 'northamerica',
    title: 'North America',
  },
  {
    code: 'southamerica',
    title: 'South America',
  },
  {
    code: 'europe',
    title: 'Europe',
  },
  {
    code: 'africa',
    title: 'Africa',
  },
  {
    code: 'asia',
    title: 'Asia',
  },
  {
    code: 'australia',
    title: 'Australia',
  },
  {
    code: 'me',
    title: 'Middle East',
  },
]

const locationPrefixContinentMap: Record<string, ContinentCode> = {
  us: 'northamerica',
  ca: 'northamerica',
  mx: 'northamerica',
  northamerica: 'northamerica',
  sa: 'southamerica',
  southamerica: 'southamerica',
  eu: 'europe',
  uk: 'europe',
  europe: 'europe',
  af: 'africa',
  africa: 'africa',
  ap: 'asia',
  asia: 'asia',
  australia: 'australia',
  me: 'me',
  il: 'me',
}

const locationContinentOverrides: Record<string, ContinentCode> = {
  'ap-sydney-1': 'australia',
  'ap-melbourne-1': 'australia',
}

export const getClusterContinent = (location: string): ContinentCode | null => {
  const normalizedLocation = location.toLowerCase()
  const [prefix = ''] = normalizedLocation.split('-')

  return (
    locationContinentOverrides[normalizedLocation] ??
    locationPrefixContinentMap[prefix] ??
    null
  )
}
